import React, { useEffect } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { TextField } from '@material-ui/core';

import * as Styled from './Login.styled';

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid e-mail address.')
    .required('E-mail address is required.')
});

interface ErrorHandlerProps {
  error?: string;
  onError?: () => void;
}

const ErrorHandler: React.FC<ErrorHandlerProps> = (
  props: ErrorHandlerProps
) => {
  const { error, onError } = props;

  useEffect(() => {
    if (error) {
      onError?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return <></>;
};

export interface JiraEmailLoginProps {
  errorMessage?: string;
  onChange?: (email: string) => void;
}

const JiraEmailLogin: React.FC<JiraEmailLoginProps> = (
  props: JiraEmailLoginProps
) => {
  const { errorMessage, onChange } = props;
  return (
    <Formik
      validateOnBlur
      validationSchema={loginSchema}
      initialValues={{ email: '' }}
      onSubmit={(dto: { email: string }) => onChange?.(dto.email)}
    >
      {({ values, errors, touched, handleChange, handleBlur, submitForm }) => (
        <Styled.StyledLoginForm>
          <TextField
            variant='outlined'
            type='email'
            name='email'
            label='Email'
            className='form-field'
            onChange={handleChange}
            onBlur={event => {
              handleBlur(event);
              submitForm();
            }}
            value={values.email}
            error={touched.email && !!errors.email}
            helperText={errors.email}
          />
          {errorMessage && <p className='error'>{errorMessage}</p>}
          {/* set empty email if error occurs */}
          <ErrorHandler error={errors.email} onError={() => onChange?.('')} />
        </Styled.StyledLoginForm>
      )}
    </Formik>
  );
};

export default JiraEmailLogin;
